import React from 'react';

import { useNavigate, useLocation } from 'react-router-dom';

import StyledTabBar from '../../../../shared/components/StyledTabBar/StyledTabBar';
import { REWARDS_POINTS_TABS } from '../../../../shared/constants/rewards';
import {
  CLICK_ACTION,
  SELECT_COLLABORATORS_POINTS_METHODS,
  REWARDS_POINTS_TABS_DICT,
  SECTION_REWARDS
} from '../../../../shared/constants/tagManager';
import TagManagerService from '../../../../shared/services/gtm/tagManagerService';

const RewardsPointsTabBar = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const getLabelTexts = REWARDS_POINTS_TABS.map((option) => option.label);

  const changeView = (newValue: number) => {
    const option = REWARDS_POINTS_TABS[newValue];
    const gtmParams = {
      section: SECTION_REWARDS,
      subsection: REWARDS_POINTS_TABS_DICT[option.id].section
    };
    TagManagerService.pushEvent(CLICK_ACTION, SELECT_COLLABORATORS_POINTS_METHODS, gtmParams);
    navigate(option.pathName);
  };

  const getCurrentOptionIndex = () => {
    const pathName = location.pathname;
    const index = REWARDS_POINTS_TABS.findIndex((option) => option.pathName === pathName);
    return index === -1 ? 0 : index;
  };

  const tabBarParams = {
    items: getLabelTexts,
    action: changeView,
    value: getCurrentOptionIndex()
  };

  return <StyledTabBar items={tabBarParams.items} action={tabBarParams.action} activeIndex={tabBarParams.value} />;
};

export default RewardsPointsTabBar;
